import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_API } from "../apiRoutes";

interface UseGetNoteListProps {
  projectId: string;
  taskId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getNoteList = async (taskId: string, projectId: string) =>
  await axiosAuth.get(`${PROJECT_API}/${projectId}/tasks/${taskId}/notes`);

const useGetNoteList = ({
  taskId,
  projectId,
  queryParams,
}: UseGetNoteListProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["note-list", taskId],
    queryFn: () => getNoteList(taskId, projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetNoteList;
